<template>
  <div class="nav">
      <router-link to="/web" >网站监控</router-link>
      <div v-if='ifYg'>
        <router-link to='/server'>服务器</router-link>
        <router-link to="/laboratory">实验室</router-link>
      </div>
      <router-link to="/me" v-if='ifLogin'>个人中心</router-link>
      <router-link to="/news" v-if='ifLogin'>消息
        <el-badge :value="$store.state.badge" :max="99" class="item" />
      </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    ifYg() {
      return this.$store.state.ifYg
    },
    ifLogin() {
      return this.$store.state.ifLogin
    }
  }
};
</script>

<style scoped lang="less">
.nav {
  width: 100%;
  color: #c7dfea;
  font-size: 18px;
  text-align: right;
  font-weight: 350;
  line-height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  a {
    margin-right: 1vw;
    margin-left: 1vw;
    text-decoration: none;
    color: #fff;
  }
  a:hover{
    color: #4f86ed;
  }
  .router-link-active{
    color: #4f86ed;
  }
}
@media screen and (max-width: 420px) {
  .nav {
    width: 100%;
    font-size: 16px;
    background: #0d114c;
    margin: auto;
    line-height: 40px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #fff;
    box-shadow: 1px 1px 1px #888;
    position: fixed;
    top:0;
    left:0;
    z-index: 100;
    a:nth-child(1){
      margin-left:0px;
    }
    a {
      margin-right: 0;
      width: 50%;
      text-decoration: none;
      color: #fff;
      display: inline-block;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/NxNav.vue